// @ts-nocheck
import getImageSize from "@toolkit/Framework/Common/Utilities/getImageSize";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* Store Custom Code - Start */
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const design: Styleguide["design"] = {
    /* Store Custom Code - Start */
    accordion: {
        padding: {
            horizontal: pxToRemArray([20]),
            vertical: pxToRemArray([20]),
        },
        spacing: pxToRemArray([2]),
    },
    /* Store Custom Code - End */
    product: {
        image: {
            small: getImageSize(210),
            medium: getImageSize(768),
            large: getImageSize(1200),
        },
    },
    category: {
        image: {
            small: getImageSize(768),
        },
    },
    /* Store Custom Code - Start */
    header: {
        breakpoint: "md",
        height: pxToRemArray([65, null, 80, 96]),
        padding: pxToRemArray([17, null, 15]),
        itemSpacing: pxToRemArray([4, null, 40, 50, 60]),
        subItemSpacing: pxToRemArray([2, null, 20, 36, 50]),
        iconButton: {
            size: pxToRemArray([28]),
            padding: pxToRemArray([5, null, 0]),
        },
    },
    menu: {
        panel: {
            rowWrapperPadding: pxToRem(0, 0),
        },
        mainNavigation: {
            height: pxToRemArray([45, null, null, 48]),
            itemSpacing: pxToRemArray([27]),
            megaMenuFullWidth: false,
            underlineSize: pxToRem(2),
        },
        secondaryNavigation: {
            height: pxToRemArray([36]),
            itemSpacing: pxToRemArray([35, null, null, 40]),
            iconSpacing: pxToRem(7),
            separatorSize: pxToRem(0),
        },
    },
    typography: {
        fontFamily: {
            title: `'Cencora', sans-serif, 'Arial'`,
            base: `'Cencora', sans-serif, 'Arial'`,
        },
    },
    /* Store Custom Code - End */
};

export default design;
